
import axios from 'axios';
export default {
  data() {
    return {
      folders: [],
      selected: '',
      selectedYear: '',
      search: '',
      open: false,
      page: 1,
      pagerMax: 10,
      limit: 9
    }
  },
  created(){
    this.getList();
  },
  computed: {
    pager(){


      let start = this.page - Math.floor(this.pagerMax / 2);

      if(start < 1 ) start = 1;

      let end = start + this.pagerMax;

      if(end > this.pages) end = this.pages;


      if(start > 1 && (((end - start) + 1) < this.pagerMax)){
        start = end - this.pagerMax;
        if(start < 1 ) start = 1;
      }

      const total = end - start + 1;
      const numbers = Array(this.pages).fill().map((_, i) => i+1);;

      return {
        start: start,
        total: total,
        numbers: numbers,
        end: end
      }
    },
    pages(){
      return Math.ceil(this.resultPool.length / this.limit);
    },
    resultPaged(){
      return this.resultPool.slice((this.page - 1) * this.limit, this.page * this.limit);
    },
    resultPool(){
      const self = this;
      if(this.selected.length === 0) return [];

      return this.folders.find(function(folder){
        return folder.name === self.selected;
      }).files[self.selectedYear];
    },
    foldersPool(){
      const self = this;

      if(this.folders.length === 0 ) return [];

      return this.folders.filter(function(v,k){
        return v.name.toLowerCase().includes(self.search.trim().toLowerCase());
      });
    }
  },

  methods: {
    removeYear(folderName){

      const year = folderName.split(' ')[0]
      if(parseInt(year) > 0){
        return folderName.slice(year.length + 1);
      }

      return folderName;
    },
    sortReverse(group){
      let newArray = []

      Object.keys(group)
      .sort()
      .reverse()
      .forEach(key => {
        newArray.push( {
          'year':key,
          'files':group[key]
        })
      })

      return newArray
    },
    openList(){
      this.open = true;
    },
    setSelected(folder,year){
      this.selected = folder;
      this.selectedYear = year;
      this.open = false;
      this.page = 1;
    },
    getList(){

      const self = this;

      axios.get('/wp-admin/admin-ajax.php',{
        params: {
          action: 'get_disclosures'
        }
      }).then( function (response) {

        if(response.data){
          for (var i = 0; i < response.data.folders.length; i++) {
            self.folders.push(response.data.folders[i]);
          }
        }
      })
    }
  }
}
